import React from 'react';
import { Grid } from 'semantic-ui-react';
import FormValidationError from './FormValidationError';

const ColumnValidationError = ({
  children,
  error,
  position = 'right',
  htmlFor,
  labelText,
  labelId,
}) => (
  <Grid.Column>
    <FormValidationError error={error} position={position} htmlFor={htmlFor} labelText={labelText} labelId={labelId}>
      {children}
    </FormValidationError>
  </Grid.Column>
);

export default ColumnValidationError;
